/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_TaglineInputs */

const en_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace manual, repetitive work with systems that run themselves.`)
};

const ar_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استبدل العمل اليدوي والمتكرر بأنظمة تعمل بنفسها.`)
};

const bn_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ম্যানুয়াল, পুনরাবৃত্তিমূলক কাজ প্রতিস্থাপন করুন সিস্টেম দিয়ে যা নিজে নিজে চলে।`)
};

const de_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen Sie manuelle, sich wiederholende Arbeiten durch Systeme, die selbst laufen.`)
};

const es_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sustituir el trabajo manual y repetitivo por sistemas que se ejecuten solos.`)
};

const fr_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacez le travail manuel et répétitif par des systèmes qui fonctionnent tout seuls.`)
};

const pt_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua o trabalho manual e repetitivo por sistemas que funcionam sozinhos.`)
};

const zh_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用自动运行的系统取代手动重复性工作。`)
};

const tr_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manüel, tekrarlanan işleri kendi kendine çalışan sistemlerle değiştirin.`)
};

const ru_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замените ручную, повторяющуюся работу системами, которые работают сами по себе.`)
};

const pl_svc_automation_tagline = /** @type {(inputs: Svc_Automation_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zastąp ręczną, powtarzalną pracę systemami, które działają samodzielnie.`)
};

/**
* | output |
* | --- |
* | "Replace manual, repetitive work with systems that run themselves." |
*
* @param {Svc_Automation_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_tagline = /** @type {((inputs?: Svc_Automation_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_tagline(inputs)
	if (locale === "bn") return bn_svc_automation_tagline(inputs)
	if (locale === "de") return de_svc_automation_tagline(inputs)
	if (locale === "es") return es_svc_automation_tagline(inputs)
	if (locale === "fr") return fr_svc_automation_tagline(inputs)
	if (locale === "pt") return pt_svc_automation_tagline(inputs)
	if (locale === "zh") return zh_svc_automation_tagline(inputs)
	if (locale === "tr") return tr_svc_automation_tagline(inputs)
	if (locale === "ru") return ru_svc_automation_tagline(inputs)
	if (locale === "pl") return pl_svc_automation_tagline(inputs)
	return en_svc_automation_tagline(inputs)
});